import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import SelectTitoli from '../select/SelectTitoli';
import FieldHoc from './FieldHoc';

const SelectTitoliField = ({
    input,
    meta,
    placeholder,
    className,
    options
}) => {
    return (
        <SelectTitoli
            {...input}
            selectedItem={input.value}
            placeholder={placeholder || input.name}
            inputClassName={cx(className, {
                // TODO: supporto touch???
                'is-error': meta.error && meta.touched
            })}
        />
    );
};

SelectTitoliField.propTypes = {
    input: PropTypes.object.isRequired,
    meta: PropTypes.object.isRequired,
    placeholder: PropTypes.string,
    className: PropTypes.string
};

SelectTitoliField.defaultProps = {
    className: 'form-input'
};

export default FieldHoc(SelectTitoliField);
